import { Row } from 'react-table';
import memoize from 'lodash/memoize';
import { Filter } from '../DataGridFilterMenu/DataGridFilterTypes';

export type EnumFilterFunction = (cellValue: string | number | boolean | unknown, inputValue: string) => boolean;

const includesFilter: EnumFilterFunction = (cellValue, inputValue) => {
  // coerce cell value to string before checking equality
  return ('' + cellValue)?.trim().toLowerCase() === inputValue?.trim().toLowerCase();
};

const excludesFilter: EnumFilterFunction = (cellValue, inputValue) => {
  return ('' + cellValue)?.trim().toLowerCase() !== inputValue?.trim().toLowerCase();
};

const memoizeResolver = (...args: any[]) => args.join('_'); // eslint-disable-line
const filtersByOperator: Record<string, EnumFilterFunction> = {
  includes: memoize(includesFilter, memoizeResolver),
  excludes: memoize(excludesFilter, memoizeResolver),
};

const runAllFiltersOnRow = (row: Row, filters: Filter[]) => {
  // Find a filter that causes the row to be removed
  return !filters.find((filter) => {
    const filterFunc = filtersByOperator[filter.operator as string];
    return !filterFunc(row.values[filter.columnId as string], filter.value as string);
  });
};

const dataGridEnumFilterFunc = (rows: Row[], columnIds: string[], filterValue: Filter[]): Row[] => {
  // Get valid filters
  const filters = filterValue.filter((filter: Filter) => {
    return !!filter?.operator && !!filter?.columnId && !!filter.value && !!filtersByOperator[filter.operator];
  });

  return rows.filter((row) => {
    return runAllFiltersOnRow(row, filters);
  });
};

export default dataGridEnumFilterFunc;
